import { Check, Clipboard, Download } from 'lucide-react';
import type { TranslationKey } from '../../i18n';
import ui from '../../components/ui.module.css';
import styles from './YamlPanel.module.css';

interface YamlPanelProps {
  yaml: string;
  copied: boolean;
  t: (key: TranslationKey, values?: Record<string, string | number>) => string;
  onCopy: () => void;
  onDownload: () => void;
}

export function YamlPanel({ yaml, copied, t, onCopy, onDownload }: YamlPanelProps) {
  return (
    <section className={styles.panel} data-testid="yaml-panel">
      <header className={styles.header}>
        <div>
          <strong>{t('yaml')}</strong>
          <span>{new TextEncoder().encode(yaml).byteLength.toLocaleString()} bytes</span>
        </div>
        <div className={styles.actions}>
          <button type="button" className={ui.button} data-testid="copy-yaml" onClick={onCopy}>
            {copied ? (
              <Check size={14} strokeWidth={2} aria-hidden="true" />
            ) : (
              <Clipboard size={14} strokeWidth={1.8} aria-hidden="true" />
            )}
            {copied ? t('copied') : t('copyYaml')}
          </button>
          <button
            type="button"
            className={ui.button}
            data-testid="download-yaml"
            onClick={onDownload}
          >
            <Download size={14} strokeWidth={1.8} aria-hidden="true" />
            {t('downloadYaml')}
          </button>
        </div>
      </header>
      <textarea
        className={styles.output}
        value={yaml}
        readOnly
        wrap="off"
        spellCheck={false}
        aria-label={t('yaml')}
        data-testid="yaml-output"
      />
    </section>
  );
}
